import angular from 'angular';
import productFinderLoanFacility from './productFinderLoanFacility';

export default angular
  .module('loanProductFinder.scenes.productFinderLoanFacility', [])
  .component('productFinderLoanFacility', productFinderLoanFacility).name;
